(function () {
  if (!window.gsap || !window.ScrollTrigger || !window.SplitText) {
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var headings = window.gsap.utils.toArray('[data-heading-reveal]');

  if (!headings.length) {
    return;
  }

  window.gsap.registerPlugin(window.ScrollTrigger, window.SplitText);

  if (window.FleuraLenis) {
    window.FleuraLenis.on('scroll', window.ScrollTrigger.update);
  }

  headings.forEach(function (heading) {
    var split = window.SplitText.create(heading, {
      type: 'lines,words',
      mask: 'lines',
      linesClass: 'heading-reveal__line',
      wordsClass: 'heading-reveal__word'
    });

    window.gsap.set(split.words, { yPercent: 120 });

    window.gsap.to(split.words, {
      yPercent: 0,
      duration: 1.25,
      ease: 'expo.out',
      stagger: 0.06,
      scrollTrigger: {
        trigger: heading,
        start: 'top 88%',
        once: true
      }
    });
  });
})();
